/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{ElementNode as e,$isElementNode as n}from"lexical";import{namedSignals as o}from"@lexical/extension/namedSignals";import{effect as i}from"@lexical/extension/signals";function t(e){n(e)&&e.isInline()&&e.isEmpty()&&e.remove()}const s={build:(e,n,i)=>o(n),config:{disabled:!1},name:"@lexical/NormalizeInlineElements",register:(n,o,s)=>{const l=s.getOutput();return i(()=>{if(!l.disabled.value){const o=[];for(const{klass:i,transforms:s}of n._nodes.values())i.prototype instanceof e&&i.prototype.isInline!==e.prototype.isInline&&(s.add(t),o.push(()=>s.delete(t)));return()=>o.forEach(e=>e())}})}};export{s as NormalizeInlineElementsExtension};
